var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loader)?_c('button',{staticClass:"button button-loader",attrs:{"type":"button"}}):_c('button',{staticClass:"button",attrs:{"disabled":_vm.event.user.is_friend.type != 3},on:{"click":_vm.send}},[_vm._v("\n        "+_vm._s(_vm.$t("albums.add"))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }